import { useEffect, useState } from 'react';
import { customerService } from '@services/api/customerService';
import { formatCurrency, getTransactionTypeColor } from '@/types/customer';
import type { Transaction } from '@/types/customer';
import '../CustomerTabs.css';

interface TransactionsTabProps {
  customerId: string;
}

export const TransactionsTab = ({ customerId }: TransactionsTabProps) => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTransactions();
  }, [customerId]);

  const loadTransactions = async () => {
    const result = await customerService.getCustomerTransactions(customerId, undefined, 50);
    if (result.success && result.data) {
      setTransactions(result.data);
    }
    setLoading(false);
  };

  if (loading) return <div>Loading transactions...</div>;

  return (
    <div className="tab-content-wrapper">
      <div className="info-card">
        <h3 className="info-card-title">📊 Transaction History</h3>
        
        {transactions.length === 0 ? (
          <p className="text-secondary">No transactions found</p>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Description</th>
                  <th>Category</th>
                  <th>Amount</th>
                  <th>Type</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((txn) => (
                  <tr key={txn.id}>
                    <td className="text-small">
                      {new Date(txn.transaction_timestamp).toLocaleString()}
                    </td>
                    <td>{txn.brand_name || txn.description || 'N/A'}</td>
                    <td className="text-small">{txn.category || 'N/A'}</td>
                    <td className={`font-weight-600 color-${getTransactionTypeColor(txn.transaction_type)}`}>
                      {txn.transaction_type === 'debit' ? '-' : '+'}
                      {formatCurrency(Math.abs(Number(txn.amount)), txn.currency)}
                    </td>
                    <td className="text-capitalize">{txn.transaction_type}</td>
                    <td>
                      <span className={`status-badge status-${txn.status === 'completed' ? 'green' : txn.status === 'failed' ? 'red' : 'orange'}`}>
                        {txn.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

